<template>
  <div class="tarjeta-con-lista">
    <div v-if="portada" class="tarjeta-portada">
      <img :src="portada" alt="" />
    </div>
    <div class="tarjeta-contenido">
      <p class="tarjeta-titulo">{{ titulo }}</p>
      <p class="tarjeta-cantidad">
        {{ links_productos.links.length }} descargas
      </p>
      <div class="tarjeta-listado">
        <a
          target="_blank"
          v-for="(data, i) in links_productos.links"
          :key="i"
          :rel="data"
          :href="data.link"
        >
          <div class="link-contenido">
            <div class="info">
              <span>{{ data.nombre }} </span>
            </div>
          </div>
          <span v-if="conIconoDeDescarga" class="icono-descarga">
            <span class="icono icono-descargar" />
          </span>
        </a>
        <!--li v-for="el in elementos" :key="el.id">
          <a :href="el.url" class="tarjeta-enlace" target="_blank" rel="noopener">
            {{ el.nombre }}
          </a>
        </li-->
      </div>
    </div>
  </div>
</template>

<script>
import links_productos from "@/assets/data/links_productos.json";

export default {
  data() {
    return {
      links_productos: links_productos,
    };
  },
  name: "TarjetaLista",
  props: {
    titulo: {
      type: String,
      required: true,
    },
    portada: {
      type: String,
    },
    elementos: {
      type: Array,
      required: false,
    },
    conIconoDeDescarga: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
$tarjeta-alto: 140px;
$tarjeta-titulo-alto: 30px;
$tarjeta-cantidad-alto: 20px;
$tarjeta-listado-alto: 90px;
$espacio: $gap * 0.5;

$tarjeta-alto_md: 200px;
$tarjeta-titulo-alto_md: 64px;
$tarjeta-cantidad-alto_md: 30px;
$tarjeta-listado-alto_md: 170px;
$espacio_md: $gap;

.tarjeta-con-lista {
  display: flex;
  height: $tarjeta-alto;

  .tarjeta-portada {
    padding-right: $espacio * 0.5;
    img {
      border-radius: $espacio * 0.5;
      width: $tarjeta-alto * 0.9;
      height: $tarjeta-alto;
      object-fit: cover;
    }
  }

  .tarjeta-contenido {
    flex: 1 0;
    border-bottom: 2px solid rgba(0, 0, 0, 1);
  }

  .tarjeta-titulo {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    font-size: map-get($fuente, "size-alto");
    font-weight: 600;
    line-height: 1.3em;
    padding: $espacio * 0.25 $espacio * 0.5;
    margin: 0;
    height: $tarjeta-titulo-alto;
    overflow: hidden;
  }

  .tarjeta-cantidad {
    font-size: map-get($fuente, "size-notas");
    padding: $espacio * 0.25 $espacio * 0.5;
    margin: 0;
    height: $tarjeta-cantidad-alto;
    overflow: hidden;
  }

  .tarjeta-listado {
    list-style: none;
    margin: 0;
    padding: 0 0 0 $espacio * 0.5;
    overflow: auto;
    height: calc($tarjeta-alto - $tarjeta-titulo-alto - $tarjeta-cantidad-alto);
    a {
      display: flex;
      font-size: map-get($fuente, "size-secundario");
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      margin: 0;
      padding: $espacio * 0.25 4px;
      align-items: center;
      justify-content: space-between;
      .link-contenido {
        display: inline-flex;
        .icono-formato {
          margin-right: 20px;
          &.zip {
            background-image: url("../assets/img/icon-folder.svg");
            width: 30px;
            height: 30px;
          }
        }
        &:hover {
          .icono-formato {
            &.zip {
              background-image: url("../assets/img/icon-folder-fff.svg");
            }
          }
        }
        .info {
          display: flex;
          flex-direction: column;
          .detalles {
            font-size: 12px;
            b {
              margin-left: 10px;
            }
          }
        }
      }
      .icono-descarga {
        background-color: #ccc;
        margin-left: 20px;
        width: 30px;
        height: 30px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 38px;
        border-radius: 50%;
      }
    }
  }
}
@media (min-width: map-get($media-queries-limit, "mobile")) {
  .tarjeta-con-lista {
    height: $tarjeta-alto_md;

    .tarjeta-portada {
      // padding-right: $espacio_md*1;
      img {
        border-radius: $espacio_md * 0.5;
        width: $tarjeta-alto_md;
        height: $tarjeta-alto_md;
      }
    }

    .tarjeta-titulo {
      padding: $espacio_md * 0.25 0;
      height: $tarjeta-titulo-alto_md;
    }

    .tarjeta-cantidad {
      padding: $espacio_md * 0.25 0;
      height: $tarjeta-cantidad-alto_md;
    }

    .tarjeta-listado {
      padding: 0;
      height: calc(
        $tarjeta-alto_md - $tarjeta-titulo-alto_md - $tarjeta-cantidad-alto_md
      );
      a {
        font-size: map-get($fuente, "size-primario");
        // padding: $espacio_md*.25 0;
      }
    }
  }
}
</style>
